import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentHeader from "../../common/ContentHeader";
import LearningResourceTable from "../../common/LearningResourceTable";
import { useParams } from "react-router-dom";
import { clearCurrentRescource } from "../../../store/actions/currentArticle";
import { ListingRecord } from "../../../store/actions/learningResource";
import { URL } from "../../../constants/URL";
import { retrieveLearningResource } from "../../../store/actions/learningResource";
import { filterTableRows } from "../../common/GeneralHelper";

const TrainingList = () => {
  const dispatch = useDispatch();
  const currentResourceType = useSelector((state) => state.resourceType);

  const { id } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(retrieveLearningResource({ type: "Training" }));
    if (id === undefined) {
      dispatch(clearCurrentRescource());
    }
  }, [dispatch, id]);

  const { learningResource } = useSelector((state) => state.learningResource);

  const [searchQuery, setSearchQuery] = useState("");
  const rows = learningResource;

  const handleSearchQueryChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handleClearSearchQuery = (event) => {
    setSearchQuery("");
  };

  const filteredData = filterTableRows(rows, searchQuery);

  const columns = [
    { field: "title", headerName: "Title", width: 250 },
    {
      field: "categories",
      headerName: "Category",
      flex: 1,
    },
    { field: "status", headerName: "Status", flex: 0.6 },
    {
      field: "updatedat",
      headerName: "Last Updated",
      flex: 1,
    },
  ];

  return (
    <>
      <ContentHeader
        header="Slidecasts"
        route="/new-training"
        searchQuery={searchQuery}
        onSearchQueryChange={handleSearchQueryChange}
        onClearSearchQuery={handleClearSearchQuery}
        searchPlaceholder="Search by Title, Category"
        isNearBy={false}
        count={filteredData?.length ?? 0}
      />
      <LearningResourceTable
        data={filteredData}
        resourceType="Training"
        isGating={true}
        isActivate={true}
        deleteURL={URL.RESOURCE}
        listService={ListingRecord}
        listURL={URL.LEARNING_RESOURCE_LISTING}
      />
    </>
  );
};

export default TrainingList;
